<template>
    <v-snackbar
    :top="true"
    :right="true"
    v-model="snackbar.snackbar"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    >
    {{ snackbar.text }}

    <template v-slot:action="{ attrs }">
        <v-btn
        color="red"
        text
        v-bind="attrs"
        @click="snackbar.snackbar = false"
        >
        Close
        </v-btn>
    </template>
    </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';
  export default {
    data: () => ({
    }),
    computed: {
      ...mapGetters(["snackbar"]),
    }
  }
</script>